export const ROUTES = {
  HOME: "/",
  NOT_FOUND: "*",
  MEDICAL_RECORD: "/historia-clinica",
  NEW_MEDICAL_RECORD: "/historia-clinica/nueva",
  PROFESSIONALS: "/profesionales",
  MPI: "/mpi",
  MPI_CREATE_PATIENT: "/mpi/crear-paciente",
  MPI_PATIENT_DETAIL: "/mpi/paciente/:id",
  DATA_ANALYSIS: "/analisis-data",
  DATA_ANALYSIS_AIRPORTS: "/analisis-data/aeropuertos",
  PATIENT_TIMELINE: "/historia-clinica/:id",
  AUDIT_MEDICAL_RECORD: "/historia-clinica/auditoria/:id",
  AUDIT_REGISTERS: "/historia-clinica/auditoria",
};
